import * as React from 'react';
import { Heading } from '@built/design-system';

import { AuthError, BrandingData, EmailVerificationData } from '../types';
import Footer from './Footer';
import * as styles from './Login.module.scss';
import Auth from '../containers/Auth';
import EmailVerification from '../containers/EmailVerification';
import logo from '../images/img-built-logo.svg';
import l10n from '@built/i18n';
const DEFAULT_HEADLINE = () =>
  l10n.t(
    'Login:Constant.headline',
    'Construction and renovation loans made simple.'
  );
const DEFAULT_SUBTEXT = () =>
  l10n.t(
    'Login:Constant.subtext',
    'Faster draws. Less friction. Complete visibility. Build on!'
  );

/**
 * Renders the login page UI. The portion of the page that handles actual
 * authentication is delegated to the Auth component.
 */

// TODO (abe) simplify this and remove tslint ignore below
// tslint:disable-next-line:cyclomatic-complexity
export default function Login(props: LoginProps) {
  const { branding } = props;
  const builtLogo = logo;
  const brandedLogo = (branding && branding.logoFile) || null;
  const brandingStyles =
    (branding &&
      branding.primaryColor && {
        backgroundColor: branding.primaryColor
      }) ||
    {};
  const brandingElementStyles =
    (branding &&
      branding.primaryColor && {
        backgroundColor: branding.primaryColor,
        opacity: 0.15
      }) ||
    {};

  const headline = (branding && branding.headline) || DEFAULT_HEADLINE();
  const subtext = (branding && branding.subtext) || DEFAULT_SUBTEXT();

  const Component = getComponent(props);

  return (
    <div className={styles.loginForm}>
      <div className={styles.left}>
        <div className={styles.loginFormContainer}>
          {brandedLogo ? (
            <img
              className={[styles.logo, styles.logoBranded].join(' ')}
              src={brandedLogo}
            />
          ) : (
            <img className={[styles.logo].join(' ')} src={builtLogo} />
          )}

          <Component />

          <Footer className={styles.copyright} basic={true} />
        </div>
      </div>
      <div className={styles.right}>
        <div
          className={[styles.rightTop, branding && styles.rightTopBranded].join(
            ' '
          )}
        >
          {branding && (
            <div
              style={brandingElementStyles}
              className={[styles.rightTopBrandedElement].join(' ')}
            />
          )}
        </div>
        <div style={brandingStyles} className={styles.rightBottom}>
          <div className={styles.copyContent}>
            <hr
              className={[
                styles.lineDetail,
                branding && styles.lineDetailBranded
              ].join(' ')}
            />
            <Heading
              size="xxl"
              inverted={true}
              className="margin-b-xs margin-t-0"
            >
              {headline}
            </Heading>
            <p
              className={[
                styles.textInverted,
                styles.headingLead,
                'margin-t-md'
              ].join(' ')}
            >
              {subtext}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Determines the main component of the login view that should be
 * rendered.
 *
 * @param props
 */
function getComponent(props: LoginProps) {
  if (props.emailVerificationData) {
    return EmailVerification;
  }
  return Auth;
}

export interface LoginProps {
  /** Any authentication error that should be displayed */
  authError?: AuthError;

  /** Branding data to customize the component's presentation */
  branding?: BrandingData;

  emailVerificationData?: EmailVerificationData;

  languageReady: boolean;
}



// WEBPACK FOOTER //
// ./src/components/Login.tsx